module.exports = __webpack_public_path__ + "img/honner_2.f3dc2342.webp";